<template>
<div v-if="isShow">
    <header>定額課金設定<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="title">定額課金設定</div>
        <div class="search-form-title">定額課金中の購入</div>
        <div class="txt-area">
            <p>定額課金中の購入はありません。</p>
        </div>
        <div class="title">注意事項</div>
        <div class="search-form-title">定額課金中の購入</div>
        <div class="txt-area">
            <p>有料プランは、ご購入月によるサービス提供日数のずれを防ぐため、いずれのプランも1ヶ月を30日としてサービスをご提供しております。<br>
                <br>
                お申し込み日を1日目とし、360日目（12ヶ月プラン）・180日目（6ヶ月プラン）・90日目（3ヶ月プラン）・30日目（1ヶ月プラン）を有料プラン期限日とさせていただいております。<br>
                <br>
                自動継続課金は期限が切れる24時間以内に自動的に行われます。<br>
                <br>
                期限日00:00の24時間以上前に自動更新をオフにしなければ、継続決算は自動的に更新されます。<br>
                <br>
                決算方法に問わず月額料金の月割り・日割りでのご返金は行っておりません。ご了承くださいませ。
            </p>
        </div>
        <div class="title">有料プランの更新日の確認・解約方法</div>
    </div>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean
    },
    emits: ['close'],
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
}
</script>
